export const video = (selector) => {
    // スマホサイズ判定
    const mobileSize = window.matchMedia('(max-width: 770px)');
    // API読み込み完了後実行
    window.onYouTubeIframeAPIReady = () => {
        const playerEl = document.querySelector(selector);
        if (playerEl === null) {
            return;
        }
        const videoEl = playerEl.querySelector('.video-box-target');
        if (videoEl === null) {
            return;
        }
        const videoID = videoEl.dataset.ytId;
        if (!videoID) {
            return;
        }
        const player = new YT.Player(videoEl, {
            videoId: videoID,
            playerVars: {
                rel: 0,
                controls: 1,
            },
        });
        const playButtonEl = playerEl.querySelector('.video-box-play');
        if (playButtonEl) {
            playButtonEl.addEventListener('click', () => {
                player.playVideo();
            });
        }
        // 自動再生
        player.addEventListener('onReady', () => {
            // PCサイズならオートプレイ
            if (!mobileSize.matches) {
                player.mute();
                player.playVideo();
            }
        });
        // 末尾で最初に戻す
        player.addEventListener('onStateChange', (evt) => {
            const status = evt.target.getPlayerState();
            // 再生開始
            if (status === YT.PlayerState.PLAYING) {
                playerEl.classList.remove('is-disabled');
            }
            else if (status === YT.PlayerState.ENDED) { // 再生終了
                player.seekTo(0, true);
            }
        });
    };
    // API読み込み
    window.addEventListener('DOMContentLoaded', () => {
        readYTAPI();
    });
};
/**
 * YoutubeAPIの読み込み
 */
const readYTAPI = () => {
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(script);
};
